import * as React from 'react';
import * as Konva from 'react-konva';
import TransformerContainer from './TransformerContainer';
import { shape } from 'prop-types';
import { COLOR_THEME } from '@nexxt/common/constants';
const BoxArea = ({
    shapeProps,
    isSelected,
    hide,
    onChange,
    changeEditStatus,
    selectedShapeName,
    handleOptionDelete,
    showLabel
}) => {
    const groupNode = React.useRef(null);
    const [text, setText] = React.useState(shapeProps.text);
    const [rotation, setRotation] = React.useState(shapeProps.rotation);
    const [x, setXCordinate] = React.useState(shapeProps.x);
    const [y, setYCordinate] = React.useState(shapeProps.y);

    React.useEffect(() => {
        if (text !== shapeProps.text) {
            setText(shapeProps.text);
        }
        if (x !== shapeProps.x) {
            setXCordinate(shapeProps.x);
        }
        if (y !== shapeProps.y) {
            setYCordinate(shapeProps.y);
        }
        if (rotation !== shapeProps.rotation) {
            setRotation(shapeProps.rotation);
        }
    }, [shapeProps]);

    const updateCordinates = () => {
        const currentNode = groupNode.current && groupNode.current;
        const scaleX = currentNode.scaleX();
        const scaleY = currentNode.scaleY();
        // we will reset it back
        currentNode.scaleX(1);
        currentNode.scaleY(1);
        const newShape = {
            ...shapeProps,
            rotation: currentNode.rotation(),
            x: currentNode.x(),
            y: currentNode.y(),
            width: currentNode.width() * scaleX,
            height: currentNode.height() * scaleY
        };
        onChange(newShape);
    };
    return (
        <React.Fragment>
            {showLabel && (
                <Konva.Label
                    x={x}
                    y={y > 20 ? y : y + 20}
                    rotation={rotation}
                    offsetX={-15}
                    offsetY={20}
                    width={100}
                    onMouseLeave={() => {
                        document.body.style.cursor = 'default';
                    }}
                    onMouseOver={() => {
                        document.body.style.cursor = 'text';
                    }}
                    onClick={(e) => {
                        e.evt.preventDefault();
                        e.evt.stopPropagation();
                        changeEditStatus(true);
                    }}
                >
                    <Konva.Tag fill={text ? COLOR_THEME.blue : '#e80303'} />
                    <Konva.Text
                        text={text || 'Click here to add label'}
                        fontSize={12}
                        fill="white"
                        name={`${shapeProps.boxID}-text`}
                        wrap="word"
                        padding={5}
                        height={20}
                    />
                </Konva.Label>
            )}
            {showLabel && (
                <Konva.Label
                    x={x}
                    y={y > 20 ? y : y + 20}
                    rotation={rotation}
                    width={16}
                    offsetX={1}
                    offsetY={20}
                    border
                    onMouseLeave={() => {
                        document.body.style.cursor = 'default';
                    }}
                    onMouseOver={() => {
                        document.body.style.cursor = 'pointer';
                    }}
                    onClick={(e) => {
                        e.evt.preventDefault();
                        e.evt.stopPropagation();
                        handleOptionDelete(shapeProps.boxID);
                    }}
                >
                    <Konva.Tag fill={text ? COLOR_THEME.blue : '#e80303'} />
                    <Konva.Text
                        text={'X'}
                        fontSize={10}
                        fill={'#ffffff'}
                        name={`${shapeProps.boxID}-text`}
                        align={'center'}
                        padding={6}
                        height={20}
                        x={-8}
                        y={-9}
                    />
                </Konva.Label>
            )}
            <Konva.Group
                ref={groupNode}
                name={shapeProps.boxID}
                draggable
                x={x}
                y={y}
                rotation={rotation}
                width={shapeProps.width}
                height={shapeProps.height}
                onTransformEnd={updateCordinates}
                onDragEnd={updateCordinates}
            >
                <Konva.Rect
                    name={`${shapeProps.boxID}-rect`}
                    stroke={text ? shapeProps.stroke : '#e80303'}
                    strokeWidth={shapeProps.strokeWidth}
                    width={shapeProps.width}
                    height={shapeProps.height}
                    onMouseLeave={() => {
                        document.body.style.cursor = 'default';
                    }}
                    onMouseOver={() => {
                        document.body.style.cursor = 'move';
                    }}
                    onMouseDown={(e) => changeEditStatus(false)}
                    opacity={hide ? 0.3 : 1}
                />
            </Konva.Group>
            {isSelected && (
                <TransformerContainer selectedShapeName={selectedShapeName} />
            )}
        </React.Fragment>
    );
};

export default BoxArea;
